export default {"src":"/_next/static/media/second.acd7c0ec.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};